import { useEffect, useState } from 'react';
import { addListener } from '../misc';
import { thirdPartyWallet } from '../Web3WalletHubCenter';

export const useThirdWallet = () => {
  const [, update] = useState(0);

  useEffect(() => {
    return addListener(thirdPartyWallet, 'walletChange', () => {
      update((s) => s + 1);
    });
  }, []);
  return thirdPartyWallet.activeWalletHub;
};

export const useWalletIsPending = () => {
  const [isSwitching, setIsSwitching] = useState(thirdPartyWallet.isSwitching);
  useEffect(() => {
    return addListener(thirdPartyWallet, 'switchingChange', (rs) => {
      setIsSwitching(rs);
    });
  }, []);
  return isSwitching;
};
